import { useCallback } from 'react';

import { useNocSmProcessor } from '@app/hooks/sales-manago/useNocSmProcessor';

import { IPageVisitPayload, SmEventType } from '@noc-sm-plugin';

export const useNocSmPageVisitEvent = ()=> {
    const { process } = useNocSmProcessor();

    const pushPageVisitEvent = useCallback((payload: IPageVisitPayload, type: SmEventType = SmEventType.VISIT) => {
        process({ type, date: new Date(), payload: { ...payload } });
    }, []);

    return { pushPageVisitEvent };
};